import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Board from "../board/Board";
import BoxGames from "../homeUI/BoxGames";

const tabs = [
  {
    name: "games",
    label: "Games",
    render: (campaigns, description, campaign_id, navigate) => {
      return (
        <>
          <div className="mt-4 pb-5 grid grid-cols-2">
            {campaigns?.games?.map((x, i) => (
              <BoxGames
                x={x}
                key={i}
                onRoute={() => {
                  navigate(`/campaign_id/${campaign_id}/game_id/${x.id}`);
                }}
              />
            ))}
          </div>
        </>
      );
    },
  },
  {
    name: "leaderboard",
    label: "LeaderBoard",
    render: (campaignGames, description, campaign_id, navigate) => {
      return <Board campaign_id={campaign_id} />;
    },
  },
];

const tabContentVariants = {
  initial: {
    y: 10,
    opacity: 0,
  },
  enter: {
    y: 0,
    opacity: 1,
  },
  exit: {
    y: -10,
    opacity: 0,
  },
};

function CampaignUI({ campaignGames, description }) {
  const navigate = useNavigate();
  const [campaign_id, setCampaignId] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();

  const getTabFromParams = () => {
    const tabParam = searchParams.get("tab");
    const foundTab = tabs.find((tab) => tab.name === tabParam);
    return foundTab || tabs[0]; // Default to first tab if not found
  };

  const [activeTab, setActiveTab] = useState(getTabFromParams);

  useEffect(() => {
    if (campaignGames) {
      setCampaignId(campaignGames?.id);
    }
  }, [campaignGames]);

  const handleClick = (e, tab) => {
    e.preventDefault();
    setActiveTab(tab);
    setSearchParams({ tab: tab.name });
  };

  const isSelected = (tab) => activeTab.name === tab.name;

  return (
    <div className="pb-5">
      <div className="ach-tabWrapper h-full">
        <div className="ach-tabHeader mx-auto max-w-[280px]">
          {tabs.map((tab) => (
            <div
              key={tab.name}
              className={[
                "ach-tabItem cursor-pointer",
                isSelected(tab) ? "ach-selected" : "",
              ].join(" ")}
            >
              <span onClick={(e) => handleClick(e, tab)}>{tab.label}</span>

              {isSelected(tab) && (
                <motion.div layoutId="indicator" className={"ach-indicator"} />
              )}
            </div>
          ))}
        </div>

        <div className={"ach-tabContent, pb-8"}>
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab.name || "empty"}
              variants={tabContentVariants}
              initial="initial"
              animate="enter"
              exit="exit"
              transition={{
                duration: 0.3,
              }}
            >
              {activeTab &&
                activeTab?.render(
                  campaignGames,
                  description,
                  campaign_id,
                  navigate,
                )}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}

export default CampaignUI;
